var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { "has-line": "", title: "Información de Pagos" }
      }),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("payment-info-filter", {
              attrs: {
                periods: _vm.catalog.periods,
                regions: _vm.catalog.regions,
                services: _vm.catalog.services
              },
              on: { "on-search": _vm.onSearchHandler }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col", class: { "hide-tab-header": _vm.hideTabs } },
          [
            _c(
              "custom-tab",
              {
                staticClass: "custom-tab-extended",
                on: { input: _vm.onTabChanged },
                model: {
                  value: _vm.tabIndex,
                  callback: function($$v) {
                    _vm.tabIndex = $$v
                  },
                  expression: "tabIndex"
                }
              },
              [
                _c(
                  "custom-tab-item",
                  {
                    attrs: { active: "", lazy: "", title: _vm.pendingTabTitle }
                  },
                  [
                    _vm.pendingService.data.length == 0
                      ? _c("custom-result-not-found")
                      : _vm._e(),
                    _vm.pendingService.data.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center my-3"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "color-green font-16 font-weight-normal pt-1"
                              },
                              [_vm._v(" Seleccionar Todos ")]
                            ),
                            _c("check-box", {
                              staticClass: "w-auto ml-2",
                              model: {
                                value: _vm.checkedPending,
                                callback: function($$v) {
                                  _vm.checkedPending = $$v
                                },
                                expression: "checkedPending"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._l(_vm.pendingService.data, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: `pending-service-item-${index}`,
                          staticClass: "my-2"
                        },
                        [
                          _c("payment-info-row", {
                            attrs: {
                              index: index,
                              "journal-status":
                                _vm.value.paymentJournalStatusId,
                              value: item
                            },
                            on: {
                              "on-denegate-item": _vm.onDenegateHandler,
                              "on-open-additional-section": function($event) {
                                return _vm.onOpenAdditionalSection(0, $event)
                              },
                              "on-open-deny-section": function($event) {
                                return _vm.onOpenAdditionalSection(0, $event)
                              },
                              "on-open-general-additional-section": function(
                                $event
                              ) {
                                return _vm.onOpenGeneralAdditionalSection(
                                  0,
                                  $event
                                )
                              }
                            }
                          }),
                          item.isNotEligible
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-secondary-18 p-2 rounded mt-n3 mb-3"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                                    },
                                    [
                                      _c("em", {
                                        staticClass:
                                          "fas fa-bell-exclamation pl-1"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ml-2 no-eligible-message pl-2"
                                        },
                                        [
                                          _vm._v(
                                            " El estudiante no es elegible para Becas de Transportación de acuerdo a los PEI’s firmados en el sistema. "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          item.notEligiblePayment
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-secondary-19 p-2 rounded mt-n3 mb-3"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                                    },
                                    [
                                      _c("em", {
                                        staticClass:
                                          "fa fa-times-circle color-secondary-20 mr-2"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-secondary-20 font-14 font-weight-normal"
                                        },
                                        [
                                          _vm._v(
                                            " No es posible aprobar los pagos, ya que cuenta con estudiante(s) no elegible(s) para Becas de Transportación de acuerdo a los PEI’s firmados en el sistema. "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _vm.pendingService.totalItemCount > _vm.pageSize
                      ? _c("pagination", {
                          attrs: {
                            data: _vm.pendingService,
                            "page-size": _vm.pageSize
                          },
                          on: { "pagination-go-page": _vm.onChangePendingPage }
                        })
                      : _vm._e()
                  ],
                  2
                ),
                _c(
                  "custom-tab-item",
                  {
                    attrs: {
                      active: _vm.hideTabs,
                      lazy: "",
                      title: _vm.processedTabTitle
                    }
                  },
                  [
                    _vm.processedService.data.length == 0
                      ? _c("custom-result-not-found")
                      : _vm._e(),
                    _vm.processedService.data.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center my-3"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "color-green font-16 font-weight-normal pt-1"
                              },
                              [_vm._v(" Seleccionar Todos ")]
                            ),
                            _c("check-box", {
                              staticClass: "w-auto ml-2",
                              model: {
                                value: _vm.checkedProcessed,
                                callback: function($$v) {
                                  _vm.checkedProcessed = $$v
                                },
                                expression: "checkedProcessed"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._l(_vm.processedService.data, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: `processed-service-item-${index}`,
                          staticClass: "my-2"
                        },
                        [
                          _c("payment-info-row", {
                            attrs: {
                              index: index,
                              "journal-status":
                                _vm.value.paymentJournalStatusId,
                              value: item
                            },
                            on: {
                              "on-denegate-item": _vm.onDenegateHandler,
                              "on-open-additional-section": function($event) {
                                return _vm.onOpenAdditionalSection(1, $event)
                              },
                              "on-open-deny-section": function($event) {
                                return _vm.onOpenAdditionalSection(1, $event)
                              },
                              "on-open-general-additional-section": function(
                                $event
                              ) {
                                return _vm.onOpenGeneralAdditionalSection(
                                  1,
                                  $event
                                )
                              }
                            }
                          }),
                          item.isNotEligible
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-secondary-18 p-2 rounded mt-n3 mb-3"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                                    },
                                    [
                                      _c("em", {
                                        staticClass:
                                          "fas fa-bell-exclamation pl-1"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ml-2 no-eligible-message pl-2"
                                        },
                                        [
                                          _vm._v(
                                            " El estudiante no es elegible para Becas de Transportación de acuerdo a los PEI’s firmados en el sistema. "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _vm.processedService.totalItemCount > _vm.pageSize
                      ? _c("pagination", {
                          attrs: {
                            data: _vm.processedService,
                            "page-size": _vm.pageSize
                          },
                          on: {
                            "pagination-go-page": _vm.onChangeProcessedPage
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }